import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-meubles-icon"
};
const _hoisted_1 = {
  width: "20",
  height: "12",
  viewBox: "0 0 20 12",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<path d="M1.52505 11.1997H2.10005L2.47505 9.94971H1.17505L1.52505 11.1997Z" fill="#7442EC"></path><path d="M17.9001 11.1997H18.4751L18.8251 9.94971H17.5251L17.9001 11.1997Z" fill="#7442EC"></path><path d="M16.125 0H11.275C10.65 0 10.125 0.525 10.125 1.15V5.525H17.275V1.15C17.275 0.5 16.775 0 16.125 0Z"></path><path opacity="0.4" d="M1.92505 6.425V7.025C1.92505 7.4 2.22505 7.7 2.60005 7.7H17.375C17.75 7.7 18.05 7.4 18.05 7.025V6.425C18.05 6.05 17.75 5.75 17.375 5.75H2.60005C2.22505 5.75 1.92505 6.05 1.92505 6.425Z"></path><path d="M18.75 2.2501C18.075 2.2501 17.5 2.7751 17.5 3.4001V5.5001C17.95 5.5751 18.3 5.9501 18.3 6.4251V7.0251C18.3 7.5251 17.875 7.9501 17.375 7.9501H2.6C2.1 7.9501 1.675 7.5251 1.675 7.0251V6.4251C1.675 5.9501 2.025 5.5751 2.475 5.5001V3.4001C2.475 3.1001 2.35 2.8001 2.125 2.5751C1.9 2.3501 1.575 2.2251 1.25 2.2251C0.575 2.2251 0 2.7501 0 3.3751V8.6001C0 9.2001 0.525 9.6751 1.15 9.6751H2.6H18.85C19.475 9.6751 20 9.2001 20 8.6001V3.4001C20 3.1001 19.875 2.8001 19.65 2.5751C19.4 2.3751 19.1 2.2501 18.75 2.2501Z"></path><path d="M8.7251 0H3.8751C3.2501 0 2.7251 0.525 2.7251 1.15V5.525H9.8751V1.15C9.8751 0.5 9.3751 0 8.7251 0Z"></path>', 6);
const _hoisted_8 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_8);
}
const uikitMeubles = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitMeubles as default
};
//# sourceMappingURL=uikit-meubles.vue.es.js.map
